import * as React from "react";
import { Pagination, List, Datagrid, TextField, NumberInput, EmailField, TextInput, ReferenceInput, SelectInput, ReferenceField, Edit, SimpleForm, useGetList, useDataProvider, Create, required, DateTimeInput } from 'react-admin';
import { PageListTitle, PageEditTitle, PageCreateTitle } from "../components/pageTitles";
import {default as commonStyles} from "../styles/common.js";
import Stack from '@mui/material/Stack';

export const SubscriptionList = props => (
    <List exporter={false} {...props} pagination={<Pagination rowsPerPageOptions={[10, 50]} />}>
        <PageListTitle text="Liste des offres de fidélité" />
        <Datagrid rowClick="edit">
            <TextField source="id" label="ID" />
            <TextField source="price" label="Prix client (TTC)" />
            <TextField source="amountToObtain" label="Solde obtenu (TTC)" />
        </Datagrid>
    </List>
);

export const SubscriptionEdit = props => (
    <Edit {...props}>
        <PageEditTitle text="Édition de la promotion" />
        <SimpleForm>
            <Stack direction="column" spacing={2} style={commonStyles.stackColumn}>
                <TextInput style={commonStyles.inputStyle} disabled source="id" label="Id" />
                <TextInput style={commonStyles.inputStyle} source="price" label="Prix client (TTC)" validate={required()} />
                <NumberInput style={commonStyles.inputStyle} source="amountToObtain" label="Solde obtenu (TTC)" validate={required()} />
            </Stack>
        </SimpleForm>
    </Edit>
);

export const SubscriptionCreate = props => (
    <Create {...props}>
        <PageCreateTitle text="Création d'une promotion" />
        <SimpleForm>
            <Stack direction="column" spacing={2} style={commonStyles.stackColumn}>
                <TextInput style={commonStyles.inputStyle} source="price" label="Prix client (TTC)" validate={required()} />
                <NumberInput style={commonStyles.inputStyle} source="amountToObtain" label="Solde obtenu (TTC)" validate={required()} />
            </Stack>
        </SimpleForm>
    </Create>
);